import { UserGroup } from "../types/UserGroup";

/**
 * Check if a user belongs to a specific group
 * @param userGroups User's group list or single group string
 * @param group Group to check for
 * @returns boolean indicating membership
 */
export const isInGroup = (
  userGroups: UserGroup[] | string | undefined = [], 
  group: UserGroup
): boolean => {
  // Handle string case (API model)
  if (typeof userGroups === 'string') {
    return userGroups === group;
  }
  
  // Handle array case (Auth context)
  return Array.isArray(userGroups) && userGroups.includes(group);
};

/**
 * Check if a user is a Super Admin
 * @param userGroups User's group list or single group string
 * @returns boolean indicating if user is a Super Admin
 */
export const isSuperAdmin = (userGroups: UserGroup[] | string | undefined = []): boolean => {
  return isInGroup(userGroups, UserGroup.SUPERADMIN);
};

/**
 * Check if a user is an Internal team member
 * @param userGroups User's group list or single group string
 * @returns boolean indicating if user is an Internal team member
 */
export const isInternal = (userGroups: UserGroup[] | string | undefined = []): boolean => {
  return isInGroup(userGroups, UserGroup.INTERNAL);
};

/**
 * Check if a user is a Customer
 * @param userGroups User's group list or single group string
 * @returns boolean indicating if user is a Customer
 */
export const isCustomer = (userGroups: UserGroup[] | string | undefined = []): boolean => {
  return isInGroup(userGroups, UserGroup.CUSTOMER);
};